import React, { useState } from 'react';
import './Contacts.css';
import Header from '../components/Header';
import { managers } from '../data/managers';

const Contacts = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ client_name: '', client_phone: '' });
  const [selectedManager, setSelectedManager] = useState(null);
  const [status, setStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOpenModal = (manager) => {
    setSelectedManager(manager);
    setIsModalOpen(true);
    setStatus(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData({ client_name: '', client_phone: '' });
    setStatus(null);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setStatus('pending');

    try {
      if (!formData.client_name || !formData.client_phone) {
        setStatus('error');
        setIsSubmitting(false);
        return;
      }

      const response = await fetch('/api/callback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          operator_name: selectedManager?.name || 'Не указан',
          operator_phone: selectedManager?.phone || 'Не указан',
        }),
      });

      if (!response.ok) throw new Error('Failed');

      setStatus('success');
      setFormData({ client_name: '', client_phone: '' });
      setTimeout(() => setIsModalOpen(false), 2000);
    } catch (error) {
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contacts-page">
      <Header />

      <section className="contacts-hero">
        <div className="page-container">
          <h1>Свяжитесь с нами</h1>
          <p>Наши менеджеры помогут подобрать тур, ответят на вопросы и оформят бронирование.</p>
        </div>
      </section>

      <section className="contacts-content page-section">
        <div className="page-container">
          <div className="contacts-info-grid">
            <article className="contacts-info-card">
              <h3>Телефон</h3>
              <p className="contacts-phones">
                <a href="tel:+998901886676">+998 90 188 66 76</a>
                <a href="tel:+998977099311">+998 97 709 93 11</a>
              </p>
              <span>Пн–Пт: 10:00 — 17:00</span>
            </article>
            <article className="contacts-info-card">
              <h3>Email</h3>
              <p>
                <a className="contacts-email-link" href="mailto:asiantourplus@gmail.com">
                  asiantourplus@gmail.com
                </a>
              </p>
              <span>Ответим в течение рабочего дня</span>
            </article>
            <article className="contacts-info-card">
              <h3>Офис</h3>
              <p>
                <a
                  className="contacts-office-link"
                  href="https://yandex.uz/maps/10335/tashkent/?ll=69.281258%2C41.323313&mode=poi&poi%5Bpoint%5D=69.281234%2C41.323334&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D6092374962&z=21"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ташкент, Узбекистан
                </a>
              </p>
              <span>Приём по предварительной записи</span>
            </article>
          </div>

          <h2 className="section-title">Наши менеджеры</h2>
          <p className="section-subtitle">Выберите специалиста — перезвоним или напишем в Telegram.</p>

          <div className="managers-grid">
            {managers.map((manager) => (
              <article className="manager-card" key={manager.id}>
                <img src={manager.photo} alt={manager.name} className="manager-photo" />
                <h3 className="manager-name">{manager.name}</h3>
                <p className="manager-phone">{manager.phone}</p>
                <div className="manager-actions">
                  <button type="button" className="btn-primary" onClick={() => handleOpenModal(manager)}>
                    Перезвоните мне
                  </button>
                  <a
                    href={manager.telegram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-secondary"
                  >
                    Написать в Telegram
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {isModalOpen && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target.classList.contains('modal-overlay')) handleCloseModal();
          }}
        >
          <div className="modal-content">
            <h2>Перезвоним вам — {selectedManager?.name}</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="client_name"
                placeholder="Ваше имя"
                value={formData.client_name}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="client_phone"
                placeholder="Номер телефона"
                value={formData.client_phone}
                onChange={handleChange}
                required
              />
              <div className="modal-buttons">
                <button type="submit" className="submit-btn" disabled={isSubmitting}>
                  {status === 'pending' ? 'Отправляю...' : 'Отправить'}
                </button>
                <button type="button" className="cancel-btn" onClick={handleCloseModal}>
                  Закрыть
                </button>
              </div>
              {status === 'success' && <p className="modal-status success">Заявка отправлена!</p>}
              {status === 'error' && <p className="modal-status error">Ошибка отправки. Попробуйте ещё раз.</p>}
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contacts;
